import React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import { Box, SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface ProgressCircleProps extends Pick<CircularProgressProps, 'value' | 'size' | 'color'> {
  sx?: SxProps<Theme>;
}

type Props = ProgressCircleProps;

const ProgressCircle = ({ value, size, color, sx }: Props) => {
  return (
    <>
      <svg style={{ position: 'absolute', width: 0, height: 0 }}>
        <defs>
          <linearGradient id='progress_circle_gradient' x1='0%' y1='0%' x2='0%' y2='100%'>
            <stop offset='0%' stopColor='#6389FD' />
            <stop offset='14%' stopColor='#6389FD' />
            <stop offset='90%' stopColor='#ACBFF8' />
            <stop offset='100%' stopColor='#ACBFF8' />
          </linearGradient>
        </defs>
      </svg>
      <Box position='relative' display='flex' alignItems='center'>
        <CircularProgress
          variant='determinate'
          value={100}
          color='inherit'
          size={size ?? '1rem'}
          sx={{ color: (theme) => theme.colors.neutral300, position: 'absolute' }}
        />
        <CircularProgress
          variant='determinate'
          value={value}
          color={color ?? 'info'}
          size={size ?? '1rem'}
          sx={{ ...sx, 'svg circle': { stroke: 'url(#progress_circle_gradient)' } }}
        />
      </Box>
    </>
  );
};

export default ProgressCircle;
